import type { Middleware } from 'redux';
import { isPromise } from 'app/utils/helpers';

type actionType = {
  type: string;
  payload?: Promise<unknown> | null;
  isLoading?: boolean | null;
  hasError?: Error | null;
};

type initStateReturnType = {
  isLoading: boolean;
  hasError: null;
};

export const getInitState = (actionDetails = {}): initStateReturnType => ({
  isLoading: false,
  hasError: null,
  ...actionDetails,
});

const isAsyncAction = (action: unknown): action is actionType =>
  typeof action === 'object' &&
  action !== null &&
  'type' in action &&
  typeof (action as { type?: unknown }).type === 'string';

const asyncMiddleware: Middleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (
      !isAsyncAction(action) ||
      !action.payload ||
      !isPromise(action.payload)
    ) {
      return next(action);
    }

    dispatch({ ...action, payload: null, isLoading: true, hasError: null });

    return action.payload
      .then((response) =>
        dispatch({
          ...action,
          payload: response,
          isLoading: false,
          hasError: null,
        })
      )
      .catch((error: Error) =>
        dispatch({
          ...action,
          payload: null,
          isLoading: false,
          hasError: error,
        })
      );
  };

export default asyncMiddleware;
